var _path, _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgProject40 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 36.25C28.9746 36.25 36.25 28.9746 36.25 20C36.25 11.0254 28.9746 3.75 20 3.75C11.0254 3.75 3.75 11.0254 3.75 20C3.75 28.9746 11.0254 36.25 20 36.25Z",
    fill: "#F4F4F4",
    stroke: "#F4F4F4",
    strokeWidth: 1.875
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2171_88376)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.5 11.25H20C19.3099 11.2507 18.7507 11.8099 18.75 12.5V18.75H12.5C11.8099 18.7507 11.2507 19.3099 11.25 20V28.75H28.75V12.5C28.7493 11.8099 28.1901 11.2507 27.5 11.25ZM15.625 27.5V23.125H18.125V27.5H15.625ZM27.5 27.5H19.375V22.5C19.375 22.1548 19.0952 21.875 18.75 21.875H15C14.6548 21.875 14.375 22.1548 14.375 22.5V27.5H12.5V20H20V12.5H27.5V27.5ZM21.25 15H22.5V16.25H21.25V15ZM25 15H26.25V16.25H25V15ZM21.25 18.75H22.5V20H21.25V18.75ZM25 18.75H26.25V20H25V18.75ZM21.25 22.5H22.5V23.75H21.25V22.5ZM25 22.5H26.25V23.75H25V22.5Z",
    fill: "#CACACA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2171_88376"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.5,
    height: 17.5,
    fill: "white",
    transform: "translate(11.25 11.25)"
  })))));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgProject40);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/project-40.cd39cb946cfe45e7b024ec0221357286.svg";